module.exports = __webpack_public_path__ + "static/media/logo-conlicita-verde.29434505.svg";